import ActiveIconSvg from 'components/_common/Icons/SVGIcons/ActiveIconSvg';
import AmmoIconSvg from 'components/_common/Icons/SVGIcons/AmmoIconSvg';
import AnalyticsSvg from 'components/_common/Icons/SVGIcons/AnalyticsSvg';
import AttributeSvg from 'components/_common/Icons/SVGIcons/AttributeSvg';
import BlogCategorySvg from 'components/_common/Icons/SVGIcons/BlogCategorySvg';
import BlogSvg from 'components/_common/Icons/SVGIcons/BlogSvg';
import CustomerGroupIconSvg from 'components/_common/Icons/SVGIcons/CustomerGroupIconSvg';
import CustomerIconSvg from 'components/_common/Icons/SVGIcons/CustomerIconSvg';
import EmployeeSvg from 'components/_common/Icons/SVGIcons/EmployeeSvg';
import GunIconSvg from 'components/_common/Icons/SVGIcons/GunIconSvg';
import ListLineSvg from 'components/_common/Icons/SVGIcons/ListLineSvg';
import MerchandiseIconSvg from 'components/_common/Icons/SVGIcons/MerchandiseIconSvg';
import ReviewSvg from 'components/_common/Icons/SVGIcons/ReviewSvg';
import RoleSvg from 'components/_common/Icons/SVGIcons/RoleSvg';
import SettingSvg from 'components/_common/Icons/SVGIcons/SettingSvg';
import SilencerIconSvg from 'components/_common/Icons/SVGIcons/SilencerIconSvg';
import SMSLogSvg from 'components/_common/Icons/SVGIcons/SMSLogSvg';
import SMSTemplateSvg from 'components/_common/Icons/SVGIcons/SMSTemplateSvg';
import SoldIconSvg from 'components/_common/Icons/SVGIcons/SoldIconSvg';
import { placeParamsToURL } from 'helpers/CommonHelper';
import {
  ACTIVE_GUNS_FOR_SALE_SLUG,
  BLOG_CATEGORY_SLUG,
  BLOG_SLUG,
  AFFILIATE_ANALYSIS_SLUG,
  AFFILIATE_CODE_SLUG,
  ADVERTISMENT_LOCATION_SLUG,
  ADVERTISMENT_SLUG,
  CUSTOMER_GROUP_SLUG,
  CUSTOMER_SLUG,
  EMPLOYEE_SLUG,
  ROLE_SLUG,
  REVIEW_SLUG,
  PRODUCT_REVIEW_SLUG,
  SOLD_GUNS_FOR_SALE_SLUG,
  PRODUCT_SLUG,
  PRODUCT_CATALOG_SCOPE,
  PRODUCT_SCOPE_DETAILS,
  PRODUCT_ADD_TYPE_PARAM,
  getCatalogScopeByType,
  PRODUCT_ATTRIBUTE_DYNAMIC_SLUG,
  PRODUCT_ATTRIBUTE_FIXED_SLUG,
  GENERAL_SETTING_SLUG,
  SMS_LOG_SLUG,
  SMS_TEMPLATE_SLUG,
  ORDER_REPORT_SLUG,
} from 'helpers/DataHelper';
import { canManageMerchandise, permissionSlugs } from 'helpers/PermissionHelper';
import { lazy, type ReactElement } from 'react';

interface Route {
  slug?: string;
  description?: string;
  permissions?: string[];
  title?: string;
  label?: string;
  path: string;
  element: ReactElement;
  layout?: string;
  routes?: { [key: string]: Route };
  icon?: React.ReactNode;
  // extra check on top of permissions for showing a tab (AdminTabLayout)
  isVisible?: () => boolean;
}
// const AdminModulePath = "modules/admin/pages/";
// auth pages
const LoginPage = lazy(() => import(`pages/Authentication/Login`));
const ForgotPasswordPage = lazy(() => import(`pages/Authentication/ForgotPassword`));
const ForgotPasswordUIPage = lazy(() => import(`pages/Authentication/ForgotPasswordUI`));
const ResetPasswordPage = lazy(() => import(`pages/Authentication/ResetPassword`));
const FFLSignUpPage = lazy(() => import(`pages/Authentication/FFLSignUp`));
const CustomerSignUpPage = lazy(() => import(`pages/Authentication/CustomerSignUp`));
const VerifyAccountPage = lazy(() => import(`pages/Authentication/VerifyAccount`));
// After Login pages
const admiPrefix = '/admin';
const DashboardPage = lazy(() => import('modules/admin/pages/AdminDashboard'));
const SyncPermissionPage = lazy(() => import('modules/admin/pages/AdminSyncPermission'));
const UserListPage = lazy(() => import('modules/admin/pages/AdminUser'));
const SettingsPage = lazy(() => import('modules/admin/pages/AdminSettings'));
// customer
const CustomerListPage = lazy(() => import('modules/admin/pages/AdminCustomer'));
const EditCustomerPage = lazy(() => import('modules/admin/pages/AdminCustomer/EditCustomer'));
const CustomerGroupListPage = lazy(() => import('modules/admin/pages/AdminCustomerGroups'));
// ffl
const FFLListPage = lazy(() => import('modules/admin/pages/AdminFFL'));
const FFLListUIPage = lazy(() => import('modules/admin/pages/AdminFFLListUI/FFLListUI'));
const FFLEditUIPage = lazy(() => import('modules/admin/pages/AdminFFLListUI/FFLEditUI'));
const FFLDetailPage = lazy(() => import('modules/admin/pages/AdminFFL/FFLDetail'));
const FFLDetailUpdatePage = lazy(() => import('modules/admin/pages/AdminFFL/UpdateFFL'));

//Purchase Forms
const PurchaseFormsListPage = lazy(() => import('modules/admin/pages/AdminPurchaseForms'));

// subscription plans
const SubscriptionPlanListPage = lazy(() => import('modules/admin/pages/AdminSubscriptionPlan'));
const SubscriptionPlanEditPage = lazy(
  () => import('modules/admin/pages/AdminSubscriptionPlan/EditSubscriptionPlan')
);
const SubscriptionPlanAddPage = lazy(
  () => import('modules/admin/pages/AdminSubscriptionPlan/AddSubscriptionPlan')
);
// URL Rewrite
const URLRewritePage = lazy(() => import('modules/admin/pages/AdminURLRewrite'));
// categories
const CategoriesPage = lazy(() => import('modules/admin/pages/AdminCategories'));
const ManufacturerPage = lazy(() => import('modules/admin/pages/AdminManufacturers'));
const BannerPage = lazy(() => import('modules/admin/pages/AdminBanners'));
const FAQPage = lazy(() => import('modules/admin/pages/AdminFAQ'));
const AdminDynamicModulePage = lazy(() => import('modules/admin/pages/AdminDynamicModule'));
// product
const ProductListPage = lazy(() => import('modules/admin/pages/AdminProducts'));
const ProductDetailPage = lazy(() => import('modules/admin/pages/AdminProducts/ProductDetail'));
const ProductEditPage = lazy(() => import('modules/admin/pages/AdminProducts/EditProduct'));
const ProductAddPage = lazy(() => import('modules/admin/pages/AdminProducts/AddProduct'));
const ProductDraftPage = lazy(() => import('modules/admin/pages/AdminProducts/ProductsDrafts'));
const ProductDraftEditPage = lazy(
  () => import('modules/admin/pages/AdminProducts/EditProductDraft')
);
// order
const OrderListPage = lazy(() => import('modules/admin/pages/AdminOrder'));
const OrderDetailPage = lazy(() => import('modules/admin/pages/AdminOrder/OrderDetail'));
// Reviews
const ReviewListPage = lazy(() => import('modules/admin/pages/AdminReviews'));

// Product  Reviews
const ProductReviewListPage = lazy(() => import('modules/admin/pages/AdminProductReviews'));

// message
const MessageListPage = lazy(() => import('modules/admin/pages/AdminMessage'));
const SendMessagePage = lazy(() => import('modules/admin/pages/AdminMessage/SendMessage'));
// Email Template
const EmailTemplateListPage = lazy(() => import('modules/admin/pages/AdminEmailTemplate'));
const EditEmailTemplatePage = lazy(
  () => import('modules/admin/pages/AdminEmailTemplate/EditEmailTemplate')
);
// SMS Template
const SMSTemplateListPage = lazy(() => import('modules/admin/pages/AdminSMSTemplate'));
const EditSMSTemplatePage = lazy(
  () => import('modules/admin/pages/AdminSMSTemplate/EditSMSTemplate')
);
// blogs
const BlogListPage = lazy(() => import('modules/admin/pages/AdminBlogs'));
const BlogGridListPage = lazy(() => import('modules/admin/pages/AdminBlogs/BlogGridList'));
const BlogGridListUIPage = lazy(() => import('modules/admin/pages/AdminBlogs/BlogGridUI'));
const BlogAddPage = lazy(() => import('modules/admin/pages/AdminBlogs/AddBlog'));
const BlogEditPage = lazy(() => import('modules/admin/pages/AdminBlogs/EditBlog'));
const BlogDetailPage = lazy(() => import('modules/admin/pages/AdminBlogs/BlogDetail'));
// blog category
const BlogCategoriesPage = lazy(() => import('modules/admin/pages/AdminBlogCategories'));
// Advertisement
const AdvertisementListPage = lazy(() => import('modules/admin/pages/AdminAdvertisements'));
const AdvertisementAddPage = lazy(
  () => import('modules/admin/pages/AdminAdvertisements/AddAdvertisement')
);
const AdvertisementEditPage = lazy(
  () => import('modules/admin/pages/AdminAdvertisements/EditAdvertisement')
);
const AdvertisementViewPage = lazy(
  () => import('modules/admin/pages/AdminAdvertisements/ViewAdvertisement')
);
const AdvertisementLocationPage = lazy(
  () => import('modules/admin/pages/AdminAdvertisements/AdvertisementLocation')
);
// Product attributes
const ProductAttributeListPage = lazy(() => import('modules/admin/pages/AdminProductAttributes'));
const ProductAttributeAddPage = lazy(
  () => import('modules/admin/pages/AdminProductAttributes/AddProductAttribute')
);
const ProductAttributeEditPage = lazy(
  () => import('modules/admin/pages/AdminProductAttributes/EditProductAttribute')
);
// guns for sale
const ActiveGunsListPage = lazy(() => import('modules/admin/pages/AdminActiveGunForSale'));
const SoldGunsListPage = lazy(() => import('modules/admin/pages/AdminSoldGunForSale'));

// coupon code
const CouponListPage = lazy(() => import('modules/admin/pages/AdminCoupons'));
const CouponAddPage = lazy(() => import('modules/admin/pages/AdminCoupons/AddCoupon'));
const CouponEditPage = lazy(() => import('modules/admin/pages/AdminCoupons/EditCoupon'));

const ContentPagesListPage = lazy(() => import('modules/admin/pages/AdminContentPage'));
const ContentPageAddPage = lazy(
  () => import('modules/admin/pages/AdminContentPage/AddContentPage')
);
const ContentPageEditPage = lazy(
  () => import('modules/admin/pages/AdminContentPage/EditContentPage')
);

const ContentPageDetailPage = lazy(
  () => import('modules/admin/pages/AdminContentPage/detailContentPage')
);

const TextEditorDemo = lazy(() => import('components/_common/TextEditor/editorDemo'));

const AdminAffiliateAnalysis = lazy(
  () => import('modules/admin/pages/AdminAffiliateCode/AdminAffiliateCodeAnalysis')
);
const AdminAffiliateList = lazy(
  () => import('modules/admin/pages/AdminAffiliateCode/AdminAffiliateCodeList')
);

const SidebarConfigPage = lazy(
  () => import('modules/admin/pages/AdminProfile/AdminSidebarMenuConfig')
);

const GeneralSettingListPage = lazy(() => import('modules/admin/pages/AdminGeneralSettings'));

// Transfer Request
const TransferRequestListPage = lazy(() => import('modules/admin/pages/AdminTransferRequest'));

// Transaction
const TransactionListPage = lazy(() => import('modules/admin/pages/AdminTransaction'));

// Return Request
const ReturnRequestListPage = lazy(() => import('modules/admin/pages/AdminReturnRequest'));

// Order Reports
const OrderReportListPage = lazy(() => import('modules/admin/pages/AdminOrderReport'));

// Support Requests
// const SupportRequestLayout = lazy(() => import('modules/admin/pages/AdminSupportRequest'));
const IntegrationRequestListPage = lazy(
  () => import('modules/admin/pages/AdminSupportRequest/IntegrationRequestList')
);
const ProductHelpRequestListPage = lazy(
  () => import('modules/admin/pages/AdminSupportRequest/ProductHelpRequestList')
);
const FieldRequestListPage = lazy(
  () => import('modules/admin/pages/AdminSupportRequest/FieldRequestList')
);

// Search Terms
const SearchTermsListPage = lazy(() => import('modules/admin/pages/AdminSearchTerms'));

// SMS Logs
const SmsLogListPage = lazy(() => import('modules/admin/pages/AdminSmsLog'));

export const forgotPasswordRoutes: { [key: string]: Route } = {
  forgotPasswordUI: {
    path: `/forgot-password-ui`,
    element: <ForgotPasswordUIPage />,
    layout: 'auth',
  },
};
export const loginRoutes: { [key: string]: Route } = {
  login: { path: `/login`, element: <LoginPage />, layout: 'login' },
  forgotPassword: {
    path: `/forgot-password`,
    element: <ForgotPasswordPage />,
    layout: 'forgotPassword',
  },

  resetPassword: {
    path: `/reset-password`,
    element: <ResetPasswordPage />,
    layout: 'forgotPassword',
  },
  signup: {
    path: `/ffl-sign-up`,
    element: <FFLSignUpPage />,
    layout: 'login',
  },
  customerSignup: {
    path: `/customer-sign-up`,
    element: <CustomerSignUpPage />,
    layout: 'login',
  },
  home: { path: `/`, element: <LoginPage />, layout: 'login' },
};
export const plainPageRoutes: { [key: string]: Route } = {
  verifyAccount: {
    path: `/verify-account`,
    element: <VerifyAccountPage />,
  },
};
const UIDashboardPage = lazy(() => import('modules/admin/pages/UIPages/UIDashboard'));
export const uiAdminPageRoutes: { [key: string]: Route } = {
  verifyAccount: {
    path: `/ui-dashboard`,
    element: <UIDashboardPage />,
  },
};
export const adminMainRoutes: { [key: string]: Route } = {
  syncPermission: { path: `${admiPrefix}/sync-permission`, element: <SyncPermissionPage /> },
  dashboard: { path: `${admiPrefix}`, element: <DashboardPage /> },
  userList: { path: `${admiPrefix}/users`, element: <UserListPage /> },
  editCustomer: { path: `${admiPrefix}/customers/edit/:id`, element: <EditCustomerPage /> },
  // ffl
  fflList: { path: `${admiPrefix}/ffls`, element: <FFLListPage /> },
  fflListUI: { path: `${admiPrefix}/ffls-ui`, element: <FFLListUIPage /> },
  fflEditUI: { path: `${admiPrefix}/ffls-ui/edit`, element: <FFLEditUIPage /> },
  fflDetail: { path: `${admiPrefix}/ffl/:slug`, element: <FFLDetailPage /> },
  fflUpdateDetail: {
    path: `${admiPrefix}/ffl/:slug/edit`,
    element: <FFLDetailUpdatePage />,
  },

  //Purchase Forms
  purchaseFormsList: {
    path: `${admiPrefix}/purchase-forms`,
    element: <PurchaseFormsListPage />,
  },

  // subscription
  subscriptionPlanList: {
    path: `${admiPrefix}/subscription-plan`,
    element: <SubscriptionPlanListPage />,
  },
  subscriptionPlanEdit: {
    path: `${admiPrefix}/subscription-plan/:id/edit`,
    element: <SubscriptionPlanEditPage />,
  },
  subscriptionPlanAdd: {
    path: `${admiPrefix}/subscription-plan/create`,
    element: <SubscriptionPlanAddPage />,
  },
  // URL Rewrite
  urlRewriteList: { path: `${admiPrefix}/url-rewrite`, element: <URLRewritePage /> },
  // categories
  categories: { path: `${admiPrefix}/categories`, element: <CategoriesPage /> },
  manufacturers: { path: `${admiPrefix}/manufacturers`, element: <ManufacturerPage /> },
  banners: { path: `${admiPrefix}/banners`, element: <BannerPage /> },
  faqs: { path: `${admiPrefix}/faq`, element: <FAQPage /> },
  dynamicModules: {
    path: `${admiPrefix}/other/:moduleName`,
    element: <AdminDynamicModulePage />,
  },
  dynamicModulesBase: {
    path: `${admiPrefix}/other`,
    element: <AdminDynamicModulePage />,
  },
  // product
  // productList: { path: `${admiPrefix}/product`, element: <ProductListPage /> },
  productDetail: { path: `${admiPrefix}/product/:id`, element: <ProductDetailPage /> },
  productEdit: { path: `${admiPrefix}/product/:id/edit`, element: <ProductEditPage /> },
  productAdd: { path: `${admiPrefix}/product/create`, element: <ProductAddPage /> },
  productDraft: { path: `${admiPrefix}/product/draft`, element: <ProductDraftPage /> },
  productDraftEdit: { path: `${admiPrefix}/product/draft/edit`, element: <ProductDraftEditPage /> },
  // order list
  orderList: { path: `${admiPrefix}/orders`, element: <OrderListPage /> },
  orderDetail: { path: `${admiPrefix}/orders/:id`, element: <OrderDetailPage /> },
  // message
  messageList: { path: `${admiPrefix}/messages`, element: <MessageListPage /> },
  messageDetail: { path: `${admiPrefix}/messages/:id`, element: <MessageListPage /> },
  sendMessage: { path: `${admiPrefix}/messages/create`, element: <SendMessagePage /> },
  // Email Templates
  emailTemplateList: { path: `${admiPrefix}/email-templates`, element: <EmailTemplateListPage /> },
  editEmailTemplate: {
    path: `${admiPrefix}/email-templates/:id`,
    element: <EditEmailTemplatePage />,
  },
  // blogs
  // blogsList: { path: `${admiPrefix}/blogs-list`, element: <BlogListPage /> },
  blogsGridListUI: { path: `${admiPrefix}/blogs-grid-ui`, element: <BlogGridListUIPage /> },
  blogAdd: { path: `${admiPrefix}/blog/create`, element: <BlogAddPage /> },
  blogEdit: { path: `${admiPrefix}/blog/:slug/edit`, element: <BlogEditPage /> },
  blogDetail: { path: `${admiPrefix}/blog/:slug`, element: <BlogDetailPage /> },
  // blog category
  // blogCategories: { path: `${admiPrefix}/blog-categories-list`, element: <BlogCategoriesPage /> },
  // advertisementList: { path: `${admiPrefix}/advertisements`, element: <AdvertisementListPage /> },
  advertisementAdd: {
    path: `${admiPrefix}/advertisements/create`,
    element: <AdvertisementAddPage />,
  },
  advertisementEdit: {
    path: `${admiPrefix}/advertisements/:slug/edit`,
    element: <AdvertisementEditPage />,
  },
  advertisementView: {
    path: `${admiPrefix}/advertisements/:slug`,
    element: <AdvertisementViewPage />,
  },
  // advertisementLocation: {
  //   path: `${admiPrefix}/advertisement/location`,
  //   element: <AdvertisementLocationPage />,
  // },
  // product attribute
  // productAttributeList: {
  //   path: `${admiPrefix}/attribute`,
  //   element: <ProductAttributeListPage />,
  // },
  productAttributeAdd: {
    path: `${admiPrefix}/attribute/create`,
    element: <ProductAttributeAddPage />,
  },
  productAttributeEdit: {
    path: `${admiPrefix}/attribute/:slug/edit`,
    element: <ProductAttributeEditPage />,
  },

  settings: { path: `${admiPrefix}/settings`, element: <SettingsPage /> },
  editorDemo: { path: `${admiPrefix}/editor-demo`, element: <TextEditorDemo /> },

  // coupon code
  couponList: { path: `${admiPrefix}/coupons`, element: <CouponListPage /> },
  couponAdd: { path: `${admiPrefix}/coupon/create`, element: <CouponAddPage /> },
  couponEdit: { path: `${admiPrefix}/coupon/:id/edit`, element: <CouponEditPage /> },

  contentPagesList: { path: `${admiPrefix}/content-pages`, element: <ContentPagesListPage /> },
  contentPageAdd: { path: `${admiPrefix}/content-page/create`, element: <ContentPageAddPage /> },
  contentPageEdit: {
    path: `${admiPrefix}/content-page/:id/edit`,
    element: <ContentPageEditPage />,
  },
  contentPageDetail: {
    path: `${admiPrefix}/content-page/:slug`,
    element: <ContentPageDetailPage />,
  },

  // Transfer Request
  transferRequestList: {
    path: `${admiPrefix}/transfer-request`,
    element: <TransferRequestListPage />,
  },

  // Transaction
  transactionList: {
    path: `${admiPrefix}/transactions`,
    element: <TransactionListPage />,
  },

  // Return Request
  returnRequestList: {
    path: `${admiPrefix}/return-requests`,
    element: <ReturnRequestListPage />,
  },

  // Search Terms
  searchTermsList: {
    path: `${admiPrefix}/search-terms`,
    element: <SearchTermsListPage />,
  },

  // SMS Logs
  // smsLogList: {
  //   path: `${admiPrefix}/sms-logs`,
  //   element: <SmsLogListPage />,
  // },

  // // SMS Templates
  // smsTemplateList: { path: `${admiPrefix}/sms-templates`, element: <SMSTemplateListPage /> },
  editSMSTemplate: {
    path: `${admiPrefix}/sms-templates/:id`,
    element: <EditSMSTemplatePage />,
  },
};
const AdminEmployeeListPage = lazy(() => import('modules/admin/pages/AdminEmployee'));
const AdminRoleListPage = lazy(() => import('modules/admin/pages/AdminRole'));
// Admin Employee Module
export const adminEmployeeRoutes: { [key: string]: Route } = {
  employeeList: {
    slug: EMPLOYEE_SLUG,
    description: 'employee_page_description',
    permissions: [permissionSlugs.employee_list],
    label: 'employees',
    path: `${admiPrefix}/employees`,
    element: <AdminEmployeeListPage />,
    icon: <EmployeeSvg />,
  },
  roleList: {
    slug: ROLE_SLUG,
    description: 'role_page_description',
    permissions: [permissionSlugs.role_list],
    label: 'roles',
    path: `${admiPrefix}/roles`,
    element: <AdminRoleListPage />,
    icon: <RoleSvg />,
  },
};

// Admin Review Module
export const adminReviewRoutes: { [key: string]: Route } = {
  reviewList: {
    slug: REVIEW_SLUG,
    description: 'reviews_page_description',
    permissions: [permissionSlugs.review_list],
    title: 'reviews',
    label: 'ffls',
    path: `${admiPrefix}/reviews`,
    element: <ReviewListPage />,
    icon: <ReviewSvg />,
  },
  productReviewList: {
    slug: PRODUCT_REVIEW_SLUG,
    description: 'product_reviews_page_description',
    permissions: [permissionSlugs.product_review_list, permissionSlugs.review_list],
    title: 'reviews',
    label: 'products',
    path: `${admiPrefix}/product-reviews`,
    element: <ProductReviewListPage />,
    icon: <ReviewSvg />,
  },
};
// Admin Customer Module
export const adminCustomerRoutes: { [key: string]: Route } = {
  customerList: {
    slug: CUSTOMER_SLUG,
    description: 'customer_page_description',
    permissions: [permissionSlugs.customer_list],
    label: 'customers',
    path: `${admiPrefix}/customers`,
    icon: <CustomerIconSvg />,
    element: <CustomerListPage />,
  },
  customerGroupList: {
    slug: CUSTOMER_GROUP_SLUG,
    description: 'customer_group_page_description',
    permissions: [permissionSlugs.customer_group_list],
    label: 'groups',
    path: `${admiPrefix}/customer-groups`,
    icon: <CustomerGroupIconSvg />,
    element: <CustomerGroupListPage />,
  },
};

export const adminSettingRoutes: { [key: string]: Route } = {
  generalSetting: {
    slug: GENERAL_SETTING_SLUG,
    description: 'setting_page_description',
    permissions: [permissionSlugs.general_setting],
    label: 'general',
    path: `${admiPrefix}/general-setting`,
    icon: <SettingSvg />,
    element: <GeneralSettingListPage />,
  },
};
// // Admin SMS Module - TAB routes only
export const adminSMSRoutes: { [key: string]: Route } = {
  smsLogList: {
    slug: SMS_LOG_SLUG,
    title: 'sms_logs',
    description: 'sms_log_page_description',
    permissions: [permissionSlugs.blog_list],
    label: 'sms_logs',
    path: `${admiPrefix}/sms-logs`,
    element: <SmsLogListPage />,
    icon: <SMSLogSvg />,
  },
  smsTemplateList: {
    slug: SMS_TEMPLATE_SLUG,
    title: 'sms_templates',
    description: 'sms_template_page_description',
    permissions: [permissionSlugs.blog_category_list],
    label: 'sms_templates',
    path: `${admiPrefix}/sms-templates`,
    element: <SMSTemplateListPage />,
    icon: <SMSTemplateSvg />,
  },
};
// Admin Blog Module
// export const adminBlogRoutes: { [key: string]: Route } = {
//   blogList: {
//     slug: BLOG_SLUG,
//     title: t('blog'),
//     description: t('blog_page_description'),
//     permissions: [permissionSlugs.blog_list],
//     label: t('list_view'),
//     path: `${admiPrefix}/blogs`,
//     element: <BlogListPage />,
//     icon: <BlogSvg />,
//   },
//   blogGridList: {
//     slug: BLOG_SLUG,
//     title: t('blog'),
//     description: t('blog_page_description'),
//     permissions: [permissionSlugs.blog_list],
//     label: t('grid_view'),
//     path: `${admiPrefix}/blogs-grid`,
//     element: <BlogGridListPage />,
//   },
//   blogCategoryList: {
//     slug: BLOG_CATEGORY_SLUG,
//     description: t('category_page_description'),
//     permissions: [permissionSlugs.blog_category_list],
//     label: t('categories'),
//     path: `${admiPrefix}/blog-categories`,
//     element: <BlogCategoriesPage />,
//     icon: <BlogCategorySvg />,
//   },
// };

// Admin Blog Module - TAB routes only
export const adminBlogRoutes: { [key: string]: Route } = {
  blogList: {
    slug: BLOG_SLUG,
    title: 'blog',
    description: 'blog_page_description',
    permissions: [permissionSlugs.blog_list],
    label: 'blogs',
    path: `${admiPrefix}/blogs`,
    element: <BlogListPage />,
    icon: <BlogSvg />,
  },
  blogCategoryList: {
    slug: BLOG_CATEGORY_SLUG,
    title: 'blog_categories',
    description: 'blog_category_page_description',
    permissions: [permissionSlugs.blog_category_list],
    label: 'categories',
    path: `${admiPrefix}/blog-categories`,
    element: <BlogCategoriesPage />,
    icon: <BlogCategorySvg />,
  },
};

// Non-tab child routes that still live inside AdminTabLayout shell
export const adminBlogChildRoutes: { [key: string]: Route } = {
  blogGridList: {
    slug: BLOG_SLUG,
    title: 'blog',
    description: 'blog_page_description',
    permissions: [permissionSlugs.blog_list],
    label: 'blogs',
    path: `${admiPrefix}/blogs-grid`,
    element: <BlogGridListPage />,
  },
};

export const adminAffiliateRoutes: { [key: string]: Route } = {
  analysis: {
    slug: AFFILIATE_ANALYSIS_SLUG,
    title: 'affiliate_codes',
    description: 'affiliate_code_page_description',
    permissions: [permissionSlugs.affiliate_analysis_list],
    label: 'affiliateAnalysis',
    path: `${admiPrefix}/analysis`,
    element: <AdminAffiliateAnalysis />,
    icon: <AnalyticsSvg />,
  },
  codeList: {
    slug: AFFILIATE_CODE_SLUG,
    title: 'affiliate_codes',
    description: 'affiliate_code_page_description',
    permissions: [permissionSlugs.affiliate_code_list],
    label: 'affiliateList',
    path: `${admiPrefix}/list`,
    element: <AdminAffiliateList />,
    icon: <ListLineSvg />,
  },
};

export const adminProductRoutes: { [key: string]: Route } = {
  // Firearms tab - every product not in the Ammo / Silencers / Merchandise tabs
  product: {
    slug: PRODUCT_SLUG,
    description: 'firearms_page_description',
    permissions: [permissionSlugs.product_list],
    label: 'firearms',
    path: `${admiPrefix}/products`,
    element: <ProductListPage />,
    icon: <GunIconSvg width={21} height={16} />,
  },
  ammo: {
    slug: PRODUCT_SCOPE_DETAILS.ammo.slug,
    description: 'ammo_page_description',
    permissions: [permissionSlugs.product_list],
    label: 'ammo',
    path: `${admiPrefix}/products/ammo`,
    element: <ProductListPage catalogScope={PRODUCT_CATALOG_SCOPE.ammo} />,
    icon: <AmmoIconSvg />,
  },
  silencers: {
    slug: PRODUCT_SCOPE_DETAILS.silencers.slug,
    description: 'silencers_page_description',
    permissions: [permissionSlugs.product_list],
    label: 'silencers',
    path: `${admiPrefix}/products/silencers`,
    element: <ProductListPage catalogScope={PRODUCT_CATALOG_SCOPE.silencers} />,
    icon: <SilencerIconSvg />,
  },
  // only the admin and FFLs with allow_merchandise (the page also sends anyone else back)
  merchandise: {
    slug: PRODUCT_SCOPE_DETAILS.merchandise.slug,
    description: 'merchandise_page_description',
    permissions: [permissionSlugs.product_list],
    label: 'merchandise',
    path: `${admiPrefix}/products/merchandise`,
    element: <ProductListPage catalogScope={PRODUCT_CATALOG_SCOPE.merchandise} />,
    icon: <MerchandiseIconSvg />,
    isVisible: canManageMerchandise,
  },
  attributeDynamic: {
    slug: PRODUCT_ATTRIBUTE_DYNAMIC_SLUG,
    description: 'product_attributes_page_discription',
    permissions: [permissionSlugs.product_attribute_list],
    label: 'dynamic_attributes',
    path: `${admiPrefix}/product-attribute`,
    element: <ProductAttributeListPage />,
    icon: <AttributeSvg />,
  },
  attributeFixed: {
    slug: PRODUCT_ATTRIBUTE_FIXED_SLUG,
    description: 'product_attributes_page_discription',
    permissions: [permissionSlugs.product_attribute_list],
    label: 'fixed_attributes',
    path: `${admiPrefix}/product-attribute/fixed`,
    element: <ProductAttributeListPage />,
    icon: <AttributeSvg />,
  },
};
// Products page tab a product is listed on, by its catalog type - where to go back to after
// saving / deleting it
export const getProductListTabPath = (catalogType?: string | null) => {
  const scope = getCatalogScopeByType(catalogType);
  return scope ? adminProductRoutes[scope].path : adminProductRoutes.product.path;
};
// add-product page for a catalog type - preselects it when the type has its own tab
export const getProductAddPath = (catalogType?: string | null) => {
  const scope = getCatalogScopeByType(catalogType);
  const addPath = placeParamsToURL(adminMainRoutes.productAdd.path);
  return scope ? `${addPath}?${PRODUCT_ADD_TYPE_PARAM}=${scope}` : addPath;
};
// gun for sale module
export const adminGunsForSaleRoutes: { [key: string]: Route } = {
  activeGunList: {
    slug: ACTIVE_GUNS_FOR_SALE_SLUG,
    description: 'gun_for_sale_description',
    permissions: [permissionSlugs.active_gun_list],
    title: 'guns_for_sale',
    label: 'active',
    icon: <ActiveIconSvg />,
    path: `${admiPrefix}/guns-for-sale/active`,
    element: <ActiveGunsListPage />,
  },
  soldGunList: {
    slug: SOLD_GUNS_FOR_SALE_SLUG,
    description: 'gun_for_sale_description',
    permissions: [permissionSlugs.sold_gun_list],
    title: 'guns_for_sale',
    label: 'sold',
    icon: <SoldIconSvg />,
    path: `${admiPrefix}/guns-for-sale/sold`,
    element: <SoldGunsListPage />,
  },
};

// advertisement module
export const adminAdvertisementRoutes: { [key: string]: Route } = {
  advertisementList: {
    slug: ADVERTISMENT_SLUG,
    description: 'advertisement_description',
    permissions: [permissionSlugs.advertisement_list],
    title: 'advertisement',
    label: 'ads',
    path: `${admiPrefix}/advertisements`,
    element: <AdvertisementListPage />,
  },
  advertisementLocation: {
    slug: ADVERTISMENT_LOCATION_SLUG,
    description: 'advertisement_description',
    permissions: [permissionSlugs.advertisement_location_list],
    title: 'advertisement',
    label: 'locations',
    path: `${admiPrefix}/advertisement/location`,
    element: <AdvertisementLocationPage />,
  },
};
// Admin profile.......................
const AdminProfileGeneralInfoPage = lazy(
  () => import('modules/admin/pages/AdminProfile/ProfileGeneralInfo')
);
const AdminProfileChangePasswordPage = lazy(
  () => import('modules/admin/pages/AdminProfile/ChangePassword')
);
const AdminProfileFFLInfoPage = lazy(
  () => import('modules/admin/pages/AdminProfile/ProfileFFLInfo')
);
const AdminProfileAlbumImagePage = lazy(
  () => import('modules/admin/pages/AdminProfile/ProfileAlbumImages')
);

const ProfileIntegrationPage = lazy(
  () => import('modules/admin/pages/AdminProfile/ProfileIntegration')
);
const AdminProfileShippingInfoPage = lazy(
  () => import('modules/admin/pages/AdminProfile/ProfileShippingInfo')
);
const ProfileSocialLinksPage = lazy(
  () => import('modules/admin/pages/AdminProfile/ProfileSocialLinks')
);
const ProfileDirectoryLinksPage = lazy(
  () => import('modules/admin/pages/AdminProfile/ProfileDirectoryLinks')
);
const ProfileFreeShippingRulesPage = lazy(
  () => import('modules/admin/pages/AdminProfile/ProfileFreeShippingRules')
);
export const adminProfileMain = {
  path: `${admiPrefix}/profile`,
};
export const adminProfileRoutes: { [key: string]: Route } = {
  profileGeneralInfo: {
    path: `${adminProfileMain.path}/general-information`,
    element: <AdminProfileGeneralInfoPage />,
  },
  profileChangePassword: {
    path: `${adminProfileMain.path}/change-password`,
    element: <AdminProfileChangePasswordPage />,
  },
  profileFFLInfo: {
    path: `${adminProfileMain.path}/ffl-info`,
    element: <AdminProfileFFLInfoPage />,
  },
  profileAlbumImages: {
    path: `${adminProfileMain.path}/album-images`,
    element: <AdminProfileAlbumImagePage />,
  },
  profileIntergration: {
    path: `${adminProfileMain.path}/integrations`,
    element: <ProfileIntegrationPage />,
  },
  profileShippingInfo: {
    path: `${adminProfileMain.path}/shipping-configuration`,
    element: <AdminProfileShippingInfoPage />,
  },

  profileSocialLinks: {
    path: `${adminProfileMain.path}/social-links`,
    element: <ProfileSocialLinksPage />,
  },
  profileDirectoryLinks: {
    path: `${adminProfileMain.path}/directory-links`,
    element: <ProfileDirectoryLinksPage />,
  },
  profileFreeShippingRules: {
    path: `${adminProfileMain.path}/free-shipping-rules`,
    element: <ProfileFreeShippingRulesPage />,
  },
  SidebarConfigPage: {
    path: `${adminProfileMain.path}/sidebar-config`,
    element: <SidebarConfigPage />,
  },
};

export const adminSupportRequestRoutes: { [key: string]: Route } = {
  orderReportList: {
    slug: ORDER_REPORT_SLUG,
    description: 'order_reports_page_description',
    permissions: [permissionSlugs.order_report_list],
    title: 'order_reports',
    label: 'order_reports',
    path: `${admiPrefix}/support-requests/order-reports`,
    element: <OrderReportListPage />,
    icon: <ReviewSvg />,
  },
  integrationRequestList: {
    slug: 'integration_requests',
    description: 'integration_requests_page_description',
    permissions: [permissionSlugs.integration_request_list],
    title: 'integration_requests',
    label: 'integration_requests',
    path: `${admiPrefix}/support-requests/integration-requests`,
    element: <IntegrationRequestListPage />,
    icon: <ReviewSvg />,
  },
  productHelpRequestList: {
    slug: 'product_help_requests',
    description: 'product_help_requests_page_description',
    permissions: [permissionSlugs.integration_request_list], // We can use the same permission or generic for now
    title: 'product_help_requests',
    label: 'product_help_requests',
    path: `${admiPrefix}/support-requests/product-help-requests`,
    element: <ProductHelpRequestListPage />,
    icon: <ReviewSvg />,
  },
  fieldRequestList: {
    slug: 'field_requests',
    description: 'field_requests_page_description',
    permissions: [permissionSlugs.integration_request_list],
    title: 'field_requests',
    label: 'field_requests',
    path: `${admiPrefix}/support-requests/field-requests`,
    element: <FieldRequestListPage />,
    icon: <ReviewSvg />,
  },
};

export const getAdminUserHomePageRoute = (): string => {
  return adminMainRoutes.dashboard.path;
};
